module.exports = {
      id: "email-usage",
      viewBox: "0 0 135.081 135.08",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#email",
      toString: function () {
        return this.url;
      }
    }